import JobDetail5Container from "../../../components/job/detail/JobDetail5";

const JobDetail5 = () => {
  return <JobDetail5Container />;
};

export default JobDetail5;
